'use client';

import { useState, useEffect } from 'react';

export interface ScreenSize {
  isMobile: boolean;    // < 768px
  isTablet: boolean;    // 768-1024px
  isDesktop: boolean;   // > 1024px
  width: number;
}

export function useScreenSize(): ScreenSize {
  const [size, setSize] = useState<ScreenSize>({
    isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : false,
    isTablet: typeof window !== 'undefined' ? window.innerWidth >= 768 && window.innerWidth < 1024 : false,
    isDesktop: typeof window !== 'undefined' ? window.innerWidth >= 1024 : true,
    width: typeof window !== 'undefined' ? window.innerWidth : 1920,
  });

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setSize({
        isMobile: w < 768,
        isTablet: w >= 768 && w < 1024,
        isDesktop: w >= 1024,
        width: w,
      });
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size;
}

// 通用响应式工具：在小屏时拆分为单列/双列
export function responsiveGridCols(isMobile: boolean, isTablet: boolean, desktop: string, tablet: string = '1fr 1fr', mobile: string = '1fr'): string {
  if (isMobile) return mobile;
  if (isTablet) return tablet;
  return desktop;
}

// 通用响应式 padding
export function responsivePadding(isMobile: boolean | undefined, desktop: number, mobile: number = 12): string {
  return `${isMobile ? mobile : desktop}px`;
}

// 通用响应式 form item 宽度
export function formItemStyle(isMobile: boolean): React.CSSProperties {
  return isMobile
    ? { width: '100%', marginBottom: 8 }
    : {};
}
